import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-numero-serie-produit',
  templateUrl: './numero-serie-produit.component.html',
  styleUrls: ['./numero-serie-produit.component.scss']
})
export class NumeroSerieProduitComponent implements OnInit {
    showFilter = false;
    filterSummary: string = '';
  constructor() { }

  ngOnInit(): void {
  }

    toggleFilter() {
        this.showFilter = !this.showFilter;

    }
}
